import React from 'react'
import { Navbar } from '../components/Navbar';
import '../pages/home.css'
import BhagavadGitaChapter from '../AllChapters';
import About from './About';
import Contact from './Contact';
import { Link } from 'react-scroll';
import Footer from '../Footer';


function Home() {
  return (
      <>
        <Navbar/>
        <div name='home' className='home'>
          <div className='home-container'>
            
            <div className='home-text'>
              <h1>||सम्पूर्ण श्रीमद भगवत गीता|| </h1>
              <h5>Complete Shrimad Bhagwat Geeta in Hindi & English</h5>
            </div>

            <button className='home-button'>
              <Link to="chaptes" smooth={true}  duration={100}><span>Read Now</span></Link> 
            </button>

          </div>
        </div>
        <About/>
        <BhagavadGitaChapter/>
        <Contact/>
        <Footer/>
      </>
  )
}

export default Home